import { SITE_TITLE, SITE_DESCRIPTION, SITE_KEYWORDS } from '@/constants/portal';

function ensureMeta(attr, key, content) {
  if (!content) return;
  const selector = attr === 'name' ? `meta[name="${key}"]` : `meta[property="${key}"]`;
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function ensureCanonical(url) {
  if (!url) return;
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', url);
}

function resolveAbsoluteUrl(path) {
  if (!path) return '';
  if (/^https?:\/\//i.test(path)) return path;
  const base = process.env.BASE_URL || '/';
  const normalized = path.startsWith('/') ? path : `${base}${path}`;
  if (typeof window === 'undefined') return normalized;
  return `${window.location.origin}${normalized}`;
}

export function updateSeo(options = {}) {
  const {
    title,
    description = SITE_DESCRIPTION,
    keywords = SITE_KEYWORDS,
    url,
    image = '/logo.png',
    type = 'website'
  } = options;

  const fullTitle = title ? `${title} - ${SITE_TITLE}` : SITE_TITLE;
  const pageUrl = url || (typeof window !== 'undefined' ? window.location.href : '');
  const imageUrl = resolveAbsoluteUrl(image);

  document.title = fullTitle;

  ensureMeta('name', 'description', description);
  ensureMeta('name', 'keywords', keywords);
  ensureMeta('property', 'og:title', fullTitle);
  ensureMeta('property', 'og:description', description);
  ensureMeta('property', 'og:type', type);
  ensureMeta('property', 'og:site_name', SITE_TITLE);
  ensureMeta('property', 'og:locale', 'zh_CN');
  ensureMeta('property', 'og:url', pageUrl);
  ensureMeta('property', 'og:image', imageUrl);
  ensureMeta('name', 'twitter:card', 'summary');
  ensureMeta('name', 'twitter:title', fullTitle);
  ensureMeta('name', 'twitter:description', description);
  ensureMeta('name', 'twitter:image', imageUrl);

  ensureCanonical(pageUrl);
}
